import webpack from "webpack";
import WebpackDevServer from "webpack-dev-server";

import { delay } from "../../../../../../Common/AsyncUtils";
import { createConfig } from "../../../../FormWebpackConfiguration/createFormWebpackConfiguration";

import { WebpackHybridFileSystem } from "./WebpackInMemoryUtils/WebpackHybridFileSystem";

export async function runFormCompilationViaWebpackDevServer(
    gfv: string,
    formPath: string,
    resourcesDirectory: string,
    resourcesHash: string,
    buildDebugOnly: boolean,
    fileSystem: WebpackHybridFileSystem,
    port: number
): Promise<void> {
    const configs = await createConfig({
        gfv: gfv,
        resourcesHash: resourcesHash,
        formPath: formPath,
        modes: buildDebugOnly ? ["development"] : ["production", "development"],
        isLocalDev: true,
        resourcesDirectoryPath: resourcesDirectory,
    });

    const compiler = webpack(configs);
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const inputFileSystem = compiler.compilers[0].inputFileSystem as any;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    fileSystem.setInnerInputFileSystem(inputFileSystem);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    for (const singleCompiler of compiler.compilers as any[]) {
        singleCompiler.inputFileSystem = fileSystem;
        singleCompiler.watchFileSystem = fileSystem;
    }

    // @ts-ignore
    const server = new WebpackDevServer(
        {
            port: port,
            allowedHosts: "all",
            server: {
                type: "https",
                options: {
                    cert: require.resolve("../../../../Keys/localhost.pem"),
                    key: require.resolve("../../../../Keys/localhost-key.pem"),
                },
            },
            client: {
                overlay: false,
                webSocketURL: `wss://localhost.testkontur.ru:${port}/ws`,
            },
        },
        compiler
    );
    await server.start();
    await delay(1000);
}
